"use client";

import { Button } from "@/shared/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/shared/components/ui/dropdown-menu";
import { Ellipsis, Link, Send, Undo2, View, Mail, XCircle } from "lucide-react";
import { ToastService } from "@/shared/services/toast-popup-services";
import { TableRowDetailsItem } from "../../types";
import { useState } from "react";
import CancelInvitationModal from "./action-modals/cancel-invitation";
import { inviteService } from "@/shared/services/api/invite";

interface ProductRowActionsProps {
  status: TableRowDetailsItem["status"];
  item: TableRowDetailsItem;
}

export default function ProductRowActions({
  status,
  item,
}: ProductRowActionsProps) {
  const [isCancelInvitationModalOpen, setIsCancelInvitationModalOpen] =
    useState(false);

  const handleCopyLink = async () => {
    // TODO: Implement actual link generation logic
    const link = `${window.location.origin}/supplier-response/${item.user.name}`;
    try {
      await navigator.clipboard.writeText(link);
      ToastService.success({
        title: "Bağlantı kopyalandı",
      });
    } catch (err) {
      console.error("Failed to copy link:", err);
      ToastService.error({
        title: "Kopyalama başarısız",
      });
    }
  };

  const handleResendInvitation = () => {
    // TODO: Implement resend invitation logic
    ToastService.success({
      title: "Davet yeniden gönderildi",
    });
  };

  // const handleWithdrawInvitation = () => {
  //   // TODO: Implement withdraw invitation logic
  //   ToastService.success({
  //     title: "Davet geri alındı",
  //   });
  // };

  const handleCancelInvitation = () => {
    setIsCancelInvitationModalOpen(true);
  };

  const handleCancelInvitationConfirm = async () => {
    if (!item.user.inviteId) {
      ToastService.error({
        title: "Davet ID bulunamadı",
      });
      return;
    }

    try {
      const response = await inviteService.revokeInviteWidthInviteId(
        item.user.inviteId
      );

      if (response.success) {
        ToastService.success({
          title: "Davet iptal edildi",
        });
        setIsCancelInvitationModalOpen(false);
      } else {
        ToastService.error({
          title: "Davet iptal edilemedi",
        });
      }
    } catch (error) {
      console.error("Failed to cancel invitation:", error);
      ToastService.error({
        title: "Davet iptal edilirken bir hata oluştu",
      });
    }
  };

  const handleViewResponses = () => {
    // TODO: Implement view responses logic
    // console.log("View responses for:", item.user.name);
  };

  const renderMenuItems = () => {
    switch (status) {
      case "sent":
        return (
          <>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCopyLink}
            >
              <Link width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Paylaşılan linki kopyala
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleResendInvitation}
            >
              <Send width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti yeniden gönder
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCancelInvitation}
            >
              <Undo2 width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti geri al
              </span>
            </DropdownMenuItem>
          </>
        );

      case "replied":
        return (
          <>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCopyLink}
            >
              <Link width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Paylaşılan linki kopyala
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleViewResponses}
            >
              <View width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Cevapları görüntüle
              </span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleResendInvitation}
            >
              <Send width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti yeniden gönder
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCancelInvitation}
            >
              <XCircle width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti iptal et
              </span>
            </DropdownMenuItem>
          </>
        );

      case "opened":
        return (
          <>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCopyLink}
            >
              <Link width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Paylaşılan linki kopyala
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleViewResponses}
            >
              <View width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Cevapları görüntüle
              </span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleResendInvitation}
            >
              <Send width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti yeniden gönder
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCancelInvitation}
            >
              <XCircle width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti iptal et
              </span>
            </DropdownMenuItem>
          </>
        );

      case "cancelled":
        return (
          <>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleResendInvitation}
            >
              <Send width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti yeniden gönder
              </span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleCancelInvitation}
            >
              <XCircle width={16} height={16} color="#09090B" />
              <span className="font-500 text-[14px] mt-0.5">
                Daveti iptal et
              </span>
            </DropdownMenuItem>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="flex items-center justify-center w-8 h-8 bg-white rounded cursor-pointer hover:bg-accent transition-colors"
          >
            <Ellipsis className="w-4 h-4 text-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-fit">
          {renderMenuItems()}
        </DropdownMenuContent>
      </DropdownMenu>
      <CancelInvitationModal
        isOpen={isCancelInvitationModalOpen}
        onClose={() => setIsCancelInvitationModalOpen(false)}
        onConfirm={handleCancelInvitationConfirm}
        item={item}
      />
    </>
  );
}
